import {useMemo} from 'react';
import {AccountCircle, DashboardCustomize, Menu, Settings, SupervisedUserCircle} from '@mui/icons-material';
import {DASHBOARD, TRANSFER_LOG, USER_MANAGEMENT, USERS_LOG, CONFIGURATION_MANAGEMENT, GROUP_MANAGEMENT, SHOW_GROUP_MANAGEMENT, SECURITY_EVENTS_LOG, GDPR_ERASURE_LOG, VAULT_TRANSACTIONS, FORENSIC_ANALYSIS, CERTIFICATE_VERIFY} from '../../../constants/routes';
import {T} from "@tolgee/react";
import {GDPR_I18N_NS} from '../../../config/tolgee';

import KeycloakService from '../../../config/keycloak';

const useDrawerItems = () => {
    const drawerItems = useMemo(() => (
        [
            {
                text: <T keyName={"nav-menu-dashboard"} defaultValue={"Dashboard"}/>,
                route: DASHBOARD,
                pattern: DASHBOARD,
                icon: <DashboardCustomize/>,
            },
            ...KeycloakService.hasRole('role_yk_web_console_admin') ?
                [
                    {
                        text: <T keyName={"nav-menu-user-management"} defaultValue={"User Management"}/>,
                        route: USER_MANAGEMENT,
                        pattern: USER_MANAGEMENT,
                        icon: <AccountCircle/>,
                    }
                ] : [],
            ...KeycloakService.hasRole('role_yk_web_console_super_admin') ?
                [
                    {
                        text: <T keyName={"nav-menu-configuration-management"} defaultValue={"Configuration"}/>,
                        route: CONFIGURATION_MANAGEMENT,
                        pattern: CONFIGURATION_MANAGEMENT,
                        icon: <Settings/>,
                    }
                ] : [],
            ...KeycloakService.hasRole('role_yk_web_console_admin') && !KeycloakService.hasRole('role_yk_web_console_super_admin') ?
                [
                    {
                        text: <T keyName={"nav-menu-configuration-management"} defaultValue={"Configuration"}/>,
                        route: CONFIGURATION_MANAGEMENT,
                        pattern: CONFIGURATION_MANAGEMENT,
                        icon: <Settings/>,
                    }
                ] : [],
            ...SHOW_GROUP_MANAGEMENT ? [
                {
                    text: <T keyName={"nav-menu-group-management"} defaultValue={"Group Management"}/>,
                    route: GROUP_MANAGEMENT,
                    pattern: GROUP_MANAGEMENT,
                    icon: <SupervisedUserCircle/>,
                }
            ] : [],
            {
                text: <T keyName={"nav-menu-users-log"} defaultValue={`User's Log`}/>,
                route: USERS_LOG,
                pattern: USERS_LOG,
                icon: <Menu/>,
            },
            {
                text: <T keyName={"nav-menu-transfer-log"} defaultValue={"Transfer Log"}/>,
                route: TRANSFER_LOG,
                pattern: TRANSFER_LOG,
                icon: <Menu/>,
            },
            {
                text: <T keyName={"nav-menu-security-events-log"} ns={GDPR_I18N_NS} defaultValue={"Security Events Log"}/>,
                route: SECURITY_EVENTS_LOG,
                pattern: SECURITY_EVENTS_LOG,
                icon: <Menu/>,
            },
            {
                text: <T keyName={"nav-menu-vault-transactions"} defaultValue={"Vault Transactions"}/>,
                route: VAULT_TRANSACTIONS,
                pattern: VAULT_TRANSACTIONS,
                icon: <Menu/>,
            },
            {
                text: <T keyName={"nav-menu-forensic"} defaultValue={"Forensic Analysis"}/>,
                route: FORENSIC_ANALYSIS,
                pattern: FORENSIC_ANALYSIS,
                icon: <Menu/>,
            },
            {
                text: <T keyName={"nav-menu-certificate-verify"} defaultValue={"Verify FEA Certificate"}/>,
                route: CERTIFICATE_VERIFY,
                pattern: CERTIFICATE_VERIFY,
                icon: <Menu/>,
            },
            ...KeycloakService.hasRole('role_yk_web_console_super_admin') ? [
                {
                    text: <T keyName={"nav-menu-gdpr-erasure-log"} ns={GDPR_I18N_NS} defaultValue={"GDPR Erasure Log"}/>,
                    route: GDPR_ERASURE_LOG,
                    pattern: GDPR_ERASURE_LOG,
                    icon: <Menu/>,
                }
            ] : [],
        ]
    ), []);

    return [drawerItems];
};

export default useDrawerItems;
